import { SpeakeasyLogo } from 'images'
import React from 'react'

import { css } from 'design'
import { Button } from 'primitives/button'
import { Stack } from 'primitives/containers'
import { cn } from 'util/cn'

import { Avatar } from '../../shared/avatar'
import { TimelineContent } from '../timeline_content'

const dialogHeaderStyles = css({
  fontSize: '$2',
  padding: '$3 !important',
  flexDirection: 'row !important',
})

const dialogBodyStyles = css({
  padding: '$3 !important',
})

const dialogButtonStyles = css({
  padding: '0 $5',
})

const dialogPreviewStyles = css({
  alignItems: 'center !important',
  padding: '$4 0 !important',
})

const avatarStyles = css({
  width: 40,
  height: 40,
  borderRadius: '$2',
  backgroundColor: 'white',
  '> *': {
    width: 'inherit',
    height: 'inherit',
  },
})

export type UnknownPanelProps = {
  showMessages: boolean
  previewMessages: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void
  handle: string
  name: string
  subheader: string
} & React.HTMLAttributes<HTMLDivElement>

export const UnknownPanel = ({
  showMessages,
  previewMessages,
  handle,
  name,
  subheader,
  children,
}: UnknownPanelProps) => {
  return (
    <TimelineContent
      avatar={
        <div className={avatarStyles()}>
          <SpeakeasyLogo />
        </div>
      }
      timelineInfo={
        <span>
          <b className={'timeline-info__handle'}>Speakeasy</b>
          <br />
          <span>{subheader}</span>
        </span>
      }
      className={cn(dialogBodyStyles(), 'timeline__personal__actions')}
    >
      <div className={'main-row'}>
        <Stack gap="1" direction="column" className={'content'}>
          <div className={'add-contact-request'}>
            <section className={'content'}>
              <Stack
                direction={'row'}
                gap={3}
                className={cn('header', dialogHeaderStyles())}
              >
                <Avatar handle={handle} />
                {name ? (
                  <Stack direction={'column'}>
                    <div className="topic__menu__header__dropdown__primary">
                      {name}
                    </div>
                    <div className="topic__menu__header__dropdown__secondary">
                      {handle}
                    </div>
                  </Stack>
                ) : (
                  <div className="topic__menu__header__dropdown__primary">
                    {handle}
                  </div>
                )}
              </Stack>
              <section className={cn('header', dialogPreviewStyles())}>
                <Button
                  className={dialogButtonStyles()}
                  onClick={previewMessages}
                  variant={'primary'}
                >
                  {showMessages ? 'Hide Messages' : 'Preview Messages' }
                </Button>
              </section>
              <section className={cn('body', dialogBodyStyles())}>
                {children}
              </section>
            </section>
          </div>
        </Stack>
      </div>
    </TimelineContent>
  )
}
